import CircularProgress from '@material-ui/core/CircularProgress';

export default function Spinner() {
  return <CircularProgress/>;
}
